<template>
    <div class="flowing">
        <div class="center">
            <!-- <span class="iconfont icon-jiazai"></span> -->
            <img src="./images/loading.png" class="iconfont">
        </div>
    </div>
</template>
<script>
export default {
  mounted() {}
};
</script>
<style scoped>
.flowing {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 9999;
}

.center {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100px;
  height: 100px;
  margin: -50px 0 0 -50px;
}

.iconfont {
  width: 100px;
  display: inline-block;
  color: white;
  font-size: 20px;
  animation: loading 1s infinite linear;
  z-index: 9999;
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/pageload/pageload.vue